import { createAsyncThunk } from '@reduxjs/toolkit'
import History from './history-model'
import { delete_history, load_historys, store_history } from './history-service'

export const LoadHistorysAsync = createAsyncThunk<any, any>(
  'composer/load/history',
  async (params: { uid: string }) => {
    return await load_historys(params)
  },
)

export const CreateHistoryAsync = createAsyncThunk<any, any>(
  'composer/create/history',
  async (params: History) => {
    return await store_history(params)
  },
)

export const DeleteHistoryAsync = createAsyncThunk<any, any>(
  'composer/delete/history',
  async (params) => {
    return await delete_history(params)
  },
)
